import React, { useRef, useState } from 'react';
import { motion, useAnimationFrame, useMotionValue } from 'framer-motion';
import { pageSamples } from '../data/pageSamples';
const SPEED_PX_PER_SECOND = 28;
export function InsidePages() {
  const trackRef = useRef<HTMLDivElement>(null);
  const x = useMotionValue(0);
  const [paused, setPaused] = useState<boolean>(false);
  useAnimationFrame((_time, delta) => {
    if (paused) return;
    if (typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    const track = trackRef.current;
    if (!track) return;
    const half = track.scrollWidth / 2;
    if (half === 0) return;
    let next = x.get() - SPEED_PX_PER_SECOND * delta / 1000;
    if (next <= -half) next += half;
    x.set(next);
  });
  const loop = [...pageSamples, ...pageSamples];
  return <section id="inside-pages" aria-labelledby="inside-pages-title" className="w-full overflow-hidden bg-ink py-20 text-white sm:py-28" data-id="element-108" data-mp="3po9hf11jknoq">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-109" data-mp="1mndxxv5mi54v">
        <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-110" data-mp="1rlfof15dp6qd">
          Sbirciatina all&apos;interno
        </span>
        <h2 id="inside-pages-title" className="mt-5 font-display text-[2rem] font-black leading-[1.05] tracking-tight sm:text-5xl" data-id="element-111" data-mp="1dt9azmtm1dum">
          Guarda le pagine vere{' '}
          <span className="italic text-brand" data-id="element-112" data-mp="13v3a98jjidrc">dall&apos;interno.</span>
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-113" data-mp="18v7rx1w6pej5">
          Pagine reali del bundle — dalle schede di movimento per i più piccoli
          alle strutture per la danza agonistica.
        </p>
      </div>

      <div role="group" aria-roledescription="carousel" aria-label="Pagine di esempio del bundle DANCE PRONTA" className="mt-12 w-full" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} onTouchStart={() => setPaused(true)} onTouchEnd={() => setPaused(false)} data-id="element-114" data-mp="yx1scqxuokhg">
        <motion.div ref={trackRef} style={{
        x
      }} className="flex w-max items-start gap-6 px-5 sm:gap-8" data-id="element-115" data-mp="12qyvds89asc">
          {loop.map((page, index) => {
          const isClone = index >= pageSamples.length;
          return <figure key={`${page.src}-${index}`} aria-hidden={isClone} className="flex shrink-0 flex-col" data-id="element-116" data-mp="3oaba7nv3pw6l" data-mpi={index}>
                <img src={page.src} alt={isClone ? '' : `${page.title} — pagina di esempio, ${page.level}`} loading={index === 0 ? 'eager' : 'lazy'} className="h-[300px] w-auto max-w-none rounded-2xl bg-white shadow-[0_30px_70px_-30px_rgba(0,0,0,0.75)] ring-1 ring-white/10 sm:h-[440px] lg:h-[540px]" data-id="element-117" data-mp="krrmmyndbei4" />
                <figcaption className="mx-auto mt-5 max-w-[16rem] text-center sm:max-w-xs" data-id="element-118" data-mp="1b2a898x14g2g">
                  <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-119" data-mp="1fzjygqs8svrc">
                    {page.level}
                  </p>
                  <p className="mt-1.5 font-display text-base font-bold leading-snug text-white sm:text-lg" data-id="element-120" data-mp="1l1ixjogy96ih">
                    {page.title}
                  </p>
                </figcaption>
              </figure>;
        })}
        </motion.div>
      </div>

      <p className="mx-auto mt-12 max-w-xl px-5 text-center text-xs text-white/45" data-id="element-121" data-mp="1yxmqleg378td">
        Più di 640 unità e attività pronte da stampare come queste, distribuite
        nei 6 volumi.
      </p>
    </section>;
}